import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '../Button';
import { cn } from '../../lib/utils';
import { useTheme } from '../../hooks/useTheme';

/** Header button that flips between the dark (default) and light themes. */
function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useTheme();
  const isLight = theme === 'light';
  const label = isLight ? 'Switch to dark theme' : 'Switch to light theme';

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('mobile:px-2 text-white hover:bg-[#1a1a1a]', className)}
      onClick={() => setTheme(isLight ? 'dark' : 'light')}
      aria-label={label}
      title={label}
      data-cy="theme-toggle"
    >
      {isLight ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
    </Button>
  );
}

export { ThemeToggle };
